<ng-container *adaptLoading="!catchup">
    <h2><b>Facilitator</b>: {{catchup?.facilitatorPerson?.fullName}}</h2>
    <h3>For catch-up between {{catchup?.person1?.fullName}} and {{catchup?.person2?.fullName}}</h3>
    <div>on {{catchupDate}}</div>
    <h3 class="mt-4"><b>{{catchup?.facilitatorPerson?.fullName}}</b>'s Comment:</h3>
    <div [froalaView]="catchup?.facilitatorComment"></div>
</ng-container>
